import { Span } from "@tblabs/truffle";
import { Box } from "./Box";


export class ProductInfoBox extends Box
{
    constructor()
    {
        super("product__info-bottom", [
            new Box("product__info-bottom-row", [
                new Span("🚚").Class("product__info-bottom-row-icon"),
                new Span("Dostawa od\n1zł w 24h").Class("product__info-bottom-row-text"),
            ]),
            new Box("product__info-bottom-row", [
                new Span("👨‍💻").Class("product__info-bottom-row-icon"),
                new Span("Pomoc techniczna\n24/7").Class("product__info-bottom-row-text"),
            ]),
        ]);
    }
}
